module.exports = __webpack_public_path__ + "img/220.2a8c4bc0.jpg";